import { useEffect, useState } from 'react';
import { fetchPublicCourses } from './api/publicApi';

const FALLBACK_COURSES = [
  {
    id: 1,
    title: 'Introduction to the Digital Learning Platform',
    category: 'Introduction',
    cadres: ['Nurse', 'Midwife'],
    modules_count: 6,
    duration_hours: '19h 30m',
    students_count: '20+',
    rating: 4.7,
    thumbnail_url: './Card 1.png',
  },
  {
    id: 2,
    title: 'Advocacy and Accountability',
    category: 'Health Science',
    cadres: ['CHEW', 'Community Health Officer'],
    modules_count: 4,
    duration_hours: '19h 30m',
    students_count: '20+',
    rating: 4.7,
    thumbnail_url: './Card 2.png',
  },
  {
    id: 3,
    title: 'Reproductive Health',
    category: 'Health Science',
    cadres: ['Doctor', 'Nurse'],
    modules_count: 4,
    duration_hours: '19h 30m',
    students_count: '20+',
    rating: 4.7,
    thumbnail_url: './Card 3.png',
  },
];

const CourseCard = ({ course }) => (
  <div className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13 md:w-[340px] md:h-[420px] md:mt-8 sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'>
    <div className='relative px-4 py-2'>
      <img
        src={course.thumbnail_url || './Card 1.png'}
        alt={course.title}
        className='object-cover lg:w-[354px] lg:h-[239px] md:w-[300px] md:h-[220px] sm:w-[390px] sm:h-[180px]'
      />
      <span className='absolute font-normal font-raleway rounded-md bg-red-500 text-white lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1 md:top-6 md:left-4 md:text-xs md:px-2 md:py-1 sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'>
        {course.category || 'Course'}
      </span>
    </div>

    <div className='p-3 space-y-4 py-5'>
      <h3 className='font-semibold font-raleway text-orange-900 lg:text-base md:text-sm sm:text-xs'>
        {course.title}
      </h3>

      {Array.isArray(course.cadres) && course.cadres.length > 0 && (
        <div className='flex flex-wrap gap-2'>
          {course.cadres.map((cadre) => (
            <span
              key={`${course.id || course.title}-${cadre}`}
              className='inline-flex items-center rounded-full bg-orange-100 px-2 py-1 text-[10px] md:text-xs font-raleway text-orange-700'
            >
              {cadre}
            </span>
          ))}
        </div>
      )}

      <div className='py-6'>
        <div className='flex justify-between font-raleway text-gray-600 lg:text-xs md:text-[11px] sm:text-[10px] lg:mt-[-7px] md:mt-[-5px] sm:mt-[-3px]'>
          <div className='flex items-center space-x-1'>
            <span>{course.modules_count || 0} Modules</span>
          </div>

          <div className='flex items-center space-x-1'>
            <span>{course.duration_hours || 'N/A'}</span>
          </div>

          <div className='flex items-center space-x-1'>
            <span>Students {course.students_count || 0}</span>
          </div>
        </div>

        <div className='text-gray-600 text-sm font-raleway py-3'>
          <span>{course.description || 'No description available'}</span>
        </div>
      </div>
    </div>
  </div>
);

const Courseos = () => {
  const [courses, setCourses] = useState(FALLBACK_COURSES);
  const [loadingCourses, setLoadingCourses] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    fetchPublicCourses(controller.signal)
      .then((result) => {
        const data = Array.isArray(result?.data) ? result.data : [];
        if (data.length > 0) {
          setCourses(data);
        }
      })
      .catch(() => {
        // Keep fallback courses if API call fails.
      })
      .finally(() => {
        setLoadingCourses(false);
      });

    return () => controller.abort();
  }, []);

  return (
    <div>
      <section className='relative bg-orange-50 bg-cover py-20 flex justify-center items-center'>
        {/* Title */}
        <h2 className='text-4xl font-Anton text-orange-900'>
          VERIFY CERTIFICATE
        </h2>

        {/* Floating Shape 1 (top) */}
        <div className='absolute top-6 left-1/2 transform -translate-x-1/2 w-[12px] h-[12px]'>
          <img
            src='./Button.png' // your image src here
            alt='Floating Dot'
            className='w-full h-full object-contain'
          />
        </div>

        {/* Floating Shape 2 (bottom-left) */}
        <div className='absolute bottom-3 left-52 w-[80px] h-[80px]'>
          <img
            src='./wrig.png'
            alt='Floating Shape Left'
            className='w-full h-full object-contain'
          />
        </div>

        {/* Floating Shape 3 (bottom-right) */}
        <div className='absolute bottom-12 right-64 w-[15px] h-[15px]'>
          <img
            src='./Button 2.png'
            alt='Floating Dot Right'
            className='w-full h-full object-contain'
          />
        </div>
      </section>
      {/* Section 2 */}
      <section
        className='  bg-cover bg-center relative w-full h-full   px-6 md:px-20   '
        style={{ backgroundImage: "url('./Backky.jpg')" }}
      >
        {/* Decoration element */}
        <img
          src='/node.png'
          alt='Decoration'
          className='absolute top-0 right-0 w-auto h-52 object-contain'
        />

        <div className='absolute bottom-10 left-4 w-4 h-4 bg-red-500 rounded-full'></div>

        {/* Up part Section */}
        {/* Up part Section */}
        <div className='flex flex-col py-8  lg:flex-row items-start justify-between lg:items-center '>
          {/* Left Side */}
          <div className='text-center lg:text-left py-8 space-y-5'>
            {/* Badge */}
            <div className='flex items-center space-x-2 text-left mb-1'>
              <img
                src='./sphere.png'
                alt='About Us'
                className='
          lg:h-[17px] lg:w-[23px]
          md:h-[15px] md:w-[20px]
          sm:h-[13px] sm:w-[18px]
        '
              />
              <p className='text-xs md:text-sm lg:text-xs text-orange-400 font-raleway'>
                Top Popular Course
              </p>
            </div>

            {/* Heading */}
            <div>
              <h2
                className='
          font-Anton text-orange-900
          lg:text-4xl md:text-3xl sm:text-2xl
        '
              >
                Check Out Our EnRich <br /> Accredited Courses
              </h2>
            </div>
          </div>

          {/* Right Side - Button */}
        </div>

        {loadingCourses ? (
          <div className='grid grid-cols-1 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2'>
            {[1, 2, 3].map((card) => (
              <div
                key={card}
                className='bg-white shadow-lg rounded-lg overflow-hidden animate-pulse lg:w-[394px] lg:h-[448px] lg:mt-11 md:w-[340px] md:h-[420px] sm:w-[444px] sm:h-[360px]'
              >
                <div className='bg-gray-200 lg:w-[354px] lg:h-[239px] md:w-[300px] md:h-[220px] sm:w-[390px] sm:h-[180px] m-4 rounded' />
                <div className='p-4 space-y-3'>
                  <div className='h-3 bg-gray-200 rounded w-1/3' />
                  <div className='h-4 bg-gray-200 rounded w-3/4' />
                  <div className='h-3 bg-gray-200 rounded w-full' />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='grid grid-cols-1 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2'>
            {courses.map((course) => (
              <CourseCard key={course.id || course.title} course={course} />
            ))}
          </div>
        )}

        {false && (
          <>
        {/* Grid of Cards */}
        <div className='grid grid-cols-1 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2'>
          {/*Card 1 */}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
      lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-2 '>
              <img
                src='./Card 1.png'
                alt='Thumb 1'
                className=' object-cover
        lg:w-[354px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
                Introduction
              </span>
            </div>

            <div className='p-3 space-y-6'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Introduction to the Digital <br /> Learning Platform
              </h3>
              <div className=''>
                <div
                  className=' flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[1px] md:mt-[-5px] sm:mt-[-3px]'
                >
                  <div className='flex items-center space-x-1  mt-2'>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>6 Modules </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>

                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-1'>
                  <span>
                    --------------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/*Card 2*/}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
    lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-2 '>
              <img
                src='./Card 2.png'
                alt='Thumb 1'
                className='object-cover
        lg:w-[354px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
              </span>
            </div>

            <div className='p-3 space-y-4 py-5'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Advocacy and Accountability
              </h3>
              <div className='py-10'>
                <div
                  className='flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[-7px] md:mt-[-5px] sm:mt-[-3px] '
                >
                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>4 Modules </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>
                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-3'>
                  <span>
                    --------------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/*Card 3 */}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
    lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-5'>
              <img
                src='./Card 3.png'
                alt='Thumb 1'
                className='object-cover
        lg:w-[354px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
                Health Science
              </span>
            </div>

            <div className='p-3 space-y-4 py-5'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Reproductive Health
              </h3>
              <div className='py-6'>
                <div
                  className='flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[-7px] md:mt-[-5px] sm:mt-[-3px] '
                >
                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>4 Modules </span>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>
                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-3'>
                  <span>
                    -----------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Card 4  */}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
    lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-2 '>
              <img
                src='./Card 1.png'
                alt='Thumb 1'
                className=' object-cover
        lg:w-[354px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
                Introduction
              </span>
            </div>

            <div className='p-3 space-y-6'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Introduction to the Digital <br /> Learning Platform
              </h3>
              <div className=''>
                <div
                  className=' flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[1px] md:mt-[-5px] sm:mt-[-3px]'
                >
                  <div className='flex items-center space-x-1  mt-2'>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>6 Modules </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>

                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-1'>
                  <span>
                    --------------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/*Card 2*/}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
    lg:w-[394px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-2 '>
              <img
                src='./Card 2.png'
                alt='Thumb 1'
                className='object-cover
        lg:w-[354px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
                Health Science
              </span>
            </div>

            <div className='p-3 space-y-4 py-5'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Advocacy and Accountability
              </h3>
              <div className='py-10'>
                <div
                  className='flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[-7px] md:mt-[-5px] sm:mt-[-3px] '
                >
                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>4 Modules </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>
                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-3'>
                  <span>
                    --------------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/*Card 3 */}
          <div
            className='bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition
    lg:w-[364px] lg:h-[448px] lg:mt-11 lg:ml-13
    md:w-[340px] md:h-[420px] md:mt-8 md:ml-ss
    sm:w-[444px] sm:h-[360px] sm:mt-6 sm:ml-4'
          >
            <div className='relative px-4 py-5'>
              <img
                src='./Card 3.png'
                alt='Thumb 1'
                className='object-cover
        lg:w-[324px] lg:h-[239px]
        md:w-[300px] md:h-[220px]
        sm:w-[390px] sm:h-[180px]'
              />
              <span
                className=' absolute font-normal font-raleway rounded-md bg-red-500 text-white
        lg:top-8 lg:left-6 lg:text-sm lg:px-3 lg:py-1
        md:top-6 md:left-4 md:text-xs md:px-2 md:py-1
        sm:top-4 sm:left-3 sm:text-[10px] sm:px-2 sm:py-[2px]'
              >
                Health Science
              </span>
            </div>

            <div className='p-3 space-y-4 py-5'>
              <div className='flex items-center space-x-2 fojnt-raleway text-xs'>
                <span>⭐⭐⭐⭐⭐</span>
                <span>(4.7)</span>
              </div>
              <h3
                className='font-semibold font-raleway text-orange-900
        lg:text-base md:text-sm sm:text-xs'
              >
                Reproductive Health
              </h3>
              <div className='py-6'>
                <div
                  className='flex justify-between font-raleway text-gray-600
        lg:text-xs md:text-[11px] sm:text-[10px]
        lg:mt-[-7px] md:mt-[-5px] sm:mt-[-3px] '
                >
                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='11'
                      height='15'
                      viewBox='0 0 11 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.875 7.37988V9.12988H2.625V7.37988H7.875ZM10.3086 3.25098C10.4362 3.37858 10.5 3.53353 10.5 3.71582V3.87988H7V0.379883H7.16406C7.34635 0.379883 7.5013 0.443685 7.62891 0.571289L10.3086 3.25098ZM6.125 4.09863C6.125 4.28092 6.1888 4.43587 6.31641 4.56348C6.44401 4.69108 6.59896 4.75488 6.78125 4.75488H10.5V13.7236C10.5 13.9059 10.4362 14.0609 10.3086 14.1885C10.181 14.3161 10.026 14.3799 9.84375 14.3799H0.65625C0.473958 14.3799 0.31901 14.3161 0.191406 14.1885C0.0638021 14.0609 0 13.9059 0 13.7236V1.03613C0 0.853841 0.0638021 0.698893 0.191406 0.571289C0.31901 0.443685 0.473958 0.379883 0.65625 0.379883H6.125V4.09863ZM1.75 2.34863V2.78613C1.75 2.93197 1.82292 3.00488 1.96875 3.00488H4.15625C4.30208 3.00488 4.375 2.93197 4.375 2.78613V2.34863C4.375 2.2028 4.30208 2.12988 4.15625 2.12988H1.96875C1.82292 2.12988 1.75 2.2028 1.75 2.34863ZM1.75 4.09863V4.53613C1.75 4.68197 1.82292 4.75488 1.96875 4.75488H4.15625C4.30208 4.75488 4.375 4.68197 4.375 4.53613V4.09863C4.375 3.9528 4.30208 3.87988 4.15625 3.87988H1.96875C1.82292 3.87988 1.75 3.9528 1.75 4.09863ZM8.75 12.4111V11.9736C8.75 11.8278 8.67708 11.7549 8.53125 11.7549H6.34375C6.19792 11.7549 6.125 11.8278 6.125 11.9736V12.4111C6.125 12.557 6.19792 12.6299 6.34375 12.6299H8.53125C8.67708 12.6299 8.75 12.557 8.75 12.4111ZM8.75 6.94238C8.75 6.81478 8.70443 6.71452 8.61328 6.6416C8.54036 6.55046 8.4401 6.50488 8.3125 6.50488H2.1875C2.0599 6.50488 1.95052 6.55046 1.85938 6.6416C1.78646 6.71452 1.75 6.81478 1.75 6.94238V9.56738C1.75 9.69499 1.78646 9.80436 1.85938 9.89551C1.95052 9.96842 2.0599 10.0049 2.1875 10.0049H8.3125C8.4401 10.0049 8.54036 9.96842 8.61328 9.89551C8.70443 9.80436 8.75 9.69499 8.75 9.56738V6.94238Z'
                        fill='black'
                      />
                    </svg>
                    <span>4 Modules </span>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='15'
                      height='15'
                      viewBox='0 0 15 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M2.7373 2.59473C4.06803 1.264 5.6722 0.598633 7.5498 0.598633C9.42741 0.598633 11.0225 1.264 12.335 2.59473C13.6657 3.90723 14.3311 5.50228 14.3311 7.37988C14.3311 9.25749 13.6657 10.8617 12.335 12.1924C11.0225 13.5049 9.42741 14.1611 7.5498 14.1611C5.6722 14.1611 4.06803 13.5049 2.7373 12.1924C1.4248 10.8617 0.768555 9.25749 0.768555 7.37988C0.768555 5.50228 1.4248 3.90723 2.7373 2.59473ZM9.1084 10.1689C9.29069 10.2965 9.44564 10.2783 9.57324 10.1143L10.3389 9.04785C10.4665 8.86556 10.4482 8.71061 10.2842 8.58301L8.53418 7.3252V3.55176C8.53418 3.33301 8.4248 3.22363 8.20605 3.22363H6.89355C6.6748 3.22363 6.56543 3.33301 6.56543 3.55176V8.14551C6.56543 8.25488 6.611 8.34603 6.70215 8.41895L9.1084 10.1689Z'
                        fill='black'
                      />
                    </svg>
                    <span>19h 30m </span>
                  </div>

                  <div className='flex items-center space-x-1 '>
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.37598 6.86816C8.7015 7.54264 7.88118 7.87988 6.91504 7.87988C5.94889 7.87988 5.11947 7.54264 4.42676 6.86816C3.75228 6.17546 3.41504 5.34603 3.41504 4.37988C3.41504 3.41374 3.75228 2.59342 4.42676 1.91895C5.11947 1.22624 5.94889 0.879883 6.91504 0.879883C7.88118 0.879883 8.7015 1.22624 9.37598 1.91895C10.0687 2.59342 10.415 3.41374 10.415 4.37988C10.415 5.34603 10.0687 6.17546 9.37598 6.86816ZM9.37598 8.75488C10.3786 8.75488 11.2354 9.11947 11.9463 9.84863C12.6755 10.5596 13.04 11.4163 13.04 12.4189V13.5674C13.04 13.932 12.9124 14.2419 12.6572 14.4971C12.402 14.7523 12.0921 14.8799 11.7275 14.8799H2.10254C1.73796 14.8799 1.42806 14.7523 1.17285 14.4971C0.917643 14.2419 0.790039 13.932 0.790039 13.5674V12.4189C0.790039 11.4163 1.14551 10.5596 1.85645 9.84863C2.58561 9.11947 3.4515 8.75488 4.4541 8.75488H4.91895C5.55697 9.04655 6.22233 9.19238 6.91504 9.19238C7.60775 9.19238 8.27311 9.04655 8.91113 8.75488H9.37598Z'
                        fill='black'
                      />
                    </svg>
                    <span>Students 20+ </span>
                  </div>
                </div>

                <div className='text-gray-600 text-sm font-raleway py-3'>
                  <span>
                    ---------------------------------------------------------
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
          </>
        )}
      </section>

      {/* Footer */}
      <div className=''>
        <footer
          className='bg-[#121212] bg-cover bg-center  text-white font-raleway'
          style={{ backgroundImage: "url('./Background2.png')" }}
        >
          {/* Top Contact Row */}
          <div className='grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-700'>
            {/* Google Play */}
            <div className='flex items-center justify-center py-6 space-x-3 mt-[14px]'>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                <svg
                  width='29'
                  height='34'
                  viewBox='0 0 29 34'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15.3529 31.7C15.0809 31.8953 14.7544 32.0004 14.4196 32.0004C14.0847 32.0004 13.7582 31.8953 13.4862 31.7C5.43789 25.9633 -3.10378 14.1633 5.53122 5.63667C7.90179 3.30475 11.0943 1.99854 14.4196 2C17.7529 2 20.9512 3.30833 23.3079 5.635C31.9429 14.1617 23.4012 25.96 15.3529 31.7Z'
                    stroke='white'
                    stroke-width='2.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M14.4193 16.9997C15.3033 16.9997 16.1512 16.6485 16.7763 16.0234C17.4014 15.3982 17.7526 14.5504 17.7526 13.6663C17.7526 12.7823 17.4014 11.9344 16.7763 11.3093C16.1512 10.6842 15.3033 10.333 14.4193 10.333C13.5352 10.333 12.6874 10.6842 12.0622 11.3093C11.4371 11.9344 11.0859 12.7823 11.0859 13.6663C11.0859 14.5504 11.4371 15.3982 12.0622 16.0234C12.6874 16.6485 13.5352 16.9997 14.4193 16.9997Z'
                    stroke='white'
                    stroke-width='2.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              </div>
              <div className=''>
                <p className='text-orange-500 text-sm font-raleway'>Location</p>
                <span className='text-white text-sm font-bold '>
                  3 Adamu Ciroma Cresent, <br /> Off Ebitu Ukiwe Street, <br />{' '}
                  Jabi, Abuja 900108
                </span>
              </div>
            </div>

            {/* Phone Number */}
            <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                <svg
                  width='26'
                  height='26'
                  viewBox='0 0 26 26'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M24.3575 24.5212C24.2381 25.1418 23.8692 25.4576 23.2508 25.4684C17.0018 25.5774 11.6254 23.4574 7.12173 19.1083C2.61805 14.7591 0.311678 9.46001 0.2026 3.21096C0.191806 2.59257 0.494471 2.21288 1.11059 2.07189L6.16749 0.811571C6.78305 0.638041 7.22641 0.858202 7.49758 1.47205L9.93642 6.89907C10.1733 7.41584 10.0674 7.87349 9.61854 8.27201L6.73105 10.7154C7.64334 12.6203 8.86085 14.292 10.3836 15.7305C11.9069 17.2015 13.6201 18.36 15.5231 19.2058L17.9131 16.2339C18.2631 15.772 18.7168 15.6502 19.2741 15.8683L24.7829 18.1163C25.3733 18.3664 25.5925 18.8021 25.4406 19.4234L24.3575 24.5212Z'
                    fill='white'
                  />
                </svg>
              </div>
              <div className=''>
                <p className='text-orange-500 text-sm font-raleway pl-3'>
                  Phone:
                </p>
                <span className='text-white text-sm font-Sora px-3'>
                  +2347025050009
                </span>
              </div>
            </div>
            {/* Email */}
            <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                <svg
                  width='26'
                  height='20'
                  viewBox='0 0 26 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M25.4115 6.95117C25.5092 6.85352 25.6068 6.83724 25.7045 6.90234C25.8347 6.96745 25.8998 7.0651 25.8998 7.19531V17.1562C25.8998 17.8073 25.6719 18.3607 25.2162 18.8164C24.7605 19.2721 24.2071 19.5 23.5561 19.5H3.24356C2.59251 19.5 2.03913 19.2721 1.5834 18.8164C1.12767 18.3607 0.899805 17.8073 0.899805 17.1562V7.19531C0.899805 7.0651 0.948633 6.98372 1.04629 6.95117C1.1765 6.88607 1.29043 6.88607 1.38809 6.95117C2.46231 7.76497 4.96882 9.60417 8.90762 12.4688C8.97272 12.5339 9.18431 12.7129 9.54238 13.0059C9.93301 13.2988 10.2423 13.5267 10.4701 13.6895C10.698 13.8197 10.991 13.9987 11.349 14.2266C11.7071 14.4219 12.0489 14.5684 12.3744 14.666C12.7325 14.7637 13.0743 14.8125 13.3998 14.8125C13.6928 14.8125 13.9857 14.7799 14.2787 14.7148C14.5717 14.6172 14.8484 14.5195 15.1088 14.4219C15.3692 14.2917 15.6459 14.1289 15.9389 13.9336C16.2318 13.7383 16.476 13.5755 16.6713 13.4453C16.8666 13.2826 17.0945 13.1035 17.3549 12.9082C17.6153 12.7129 17.7943 12.5664 17.892 12.4688C21.7331 9.70182 24.2396 7.86263 25.4115 6.95117ZM13.3998 13.25C13.1394 13.25 12.8139 13.1686 12.4232 13.0059C12.0652 12.8105 11.7722 12.6478 11.5443 12.5176C11.3165 12.3548 10.9747 12.1107 10.5189 11.7852C10.0958 11.4271 9.8679 11.248 9.83535 11.248C5.864 8.35091 3.03197 6.2513 1.33926 4.94922C1.04629 4.72135 0.899805 4.41211 0.899805 4.02148V3.09375C0.899805 2.44271 1.12767 1.88932 1.5834 1.43359C2.03913 0.977865 2.59251 0.75 3.24356 0.75H23.5561C24.2071 0.75 24.7605 0.977865 25.2162 1.43359C25.6719 1.88932 25.8998 2.44271 25.8998 3.09375V4.02148C25.8998 4.41211 25.7533 4.72135 25.4604 4.94922C23.8653 6.1862 21.0333 8.28581 16.9643 11.248C16.9317 11.248 16.6876 11.4271 16.2318 11.7852C15.8087 12.1107 15.4831 12.3548 15.2553 12.5176C15.0274 12.6478 14.7182 12.8105 14.3275 13.0059C13.9695 13.1686 13.6602 13.25 13.3998 13.25Z'
                    fill='white'
                  />
                </svg>
              </div>
              <div className=''>
                <p className='text-orange-500 text-sm font-raleway pl-3'>
                  Email:
                </p>
                <span className='text-white text-sm font-raleway font-bold px-3 pr-4'>
                  NGA.Enrichdlp@care.org
                </span>
              </div>
            </div>
          </div>

          {/* Bottom Footer Content */}
          <div className='grid grid-cols-1 md:grid-cols-4 gap-8 py-10 px-6 md:px-16'>
            {/* Logo and Social */}
            <div className='flex flex-col items-center text-center space-y-3'>
              <img
                src='/Care-logo.png'
                alt='Care eLearning'
                className='w-[150px] sm:w-[180px] md:w-[198px] h-auto'
              />
              <div className='text-center'>
                <p className='mb-4'>
                  Follow us on any social platform to <br /> get latest updates
                  and events.
                </p>
              </div>

              <div className='flex items-center space-x-2 '>
                {/* Facebook */}
                <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                  <svg
                    width='10'
                    height='18'
                    viewBox='0 0 10 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M8.61679 9.6875H6.12655V17.125H2.80624V9.6875H0.0835857V6.63281H2.80624V4.27539C2.80624 1.61914 4.39999 0.125 6.82382 0.125C7.98593 0.125 9.21445 0.357422 9.21445 0.357422V2.98047H7.85312C6.52499 2.98047 6.12655 3.77734 6.12655 4.64062V6.63281H9.08163L8.61679 9.6875Z'
                      fill='#E8721F'
                    />
                    <a href='https://web.facebook.com/CAREinNigeria/?_rdc=1&_rdr#' target='_blank' rel='noopener noreferrer'>
                      <rect
                        fill='black'
                        fill-opacity='0'
                        x='0.162687'
                        y='-1.275'
                        width='10.625'
                        height='19.55'
                      />
                    </a>
                  </svg>
                </div>
                {/* Instagram */}
                <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                  <svg
                    width='16'
                    height='20'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M7.68632 3.80664C9.77812 3.80664 11.5047 5.5332 11.5047 7.625C11.5047 9.75 9.77812 11.4434 7.68632 11.4434C5.56132 11.4434 3.86796 9.75 3.86796 7.625C3.86796 5.5332 5.56132 3.80664 7.68632 3.80664ZM7.68632 10.1152C9.04765 10.1152 10.1434 9.01953 10.1434 7.625C10.1434 6.26367 9.04765 5.16797 7.68632 5.16797C6.29179 5.16797 5.19609 6.26367 5.19609 7.625C5.19609 9.01953 6.32499 10.1152 7.68632 10.1152ZM12.534 3.67383C12.534 4.17188 12.1355 4.57031 11.6375 4.57031C11.1394 4.57031 10.741 4.17188 10.741 3.67383C10.741 3.17578 11.1394 2.77734 11.6375 2.77734C12.1355 2.77734 12.534 3.17578 12.534 3.67383ZM15.0574 4.57031C15.1238 5.79883 15.1238 9.48438 15.0574 10.7129C14.991 11.9082 14.7254 12.9375 13.8621 13.834C12.9988 14.6973 11.9363 14.9629 10.741 15.0293C9.51249 15.0957 5.82695 15.0957 4.59843 15.0293C3.40312 14.9629 2.37382 14.6973 1.47734 13.834C0.614055 12.9375 0.34843 11.9082 0.282023 10.7129C0.215617 9.48438 0.215617 5.79883 0.282023 4.57031C0.34843 3.375 0.614055 2.3125 1.47734 1.44922C2.37382 0.585938 3.40312 0.320312 4.59843 0.253906C5.82695 0.1875 9.51249 0.1875 10.741 0.253906C11.9363 0.320312 12.9988 0.585938 13.8621 1.44922C14.7254 2.3125 14.991 3.375 15.0574 4.57031ZM13.4637 12.0078C13.8621 11.0449 13.7625 8.7207 13.7625 7.625C13.7625 6.5625 13.8621 4.23828 13.4637 3.24219C13.198 2.61133 12.7 2.08008 12.0691 1.84766C11.073 1.44922 8.74882 1.54883 7.68632 1.54883C6.59062 1.54883 4.2664 1.44922 3.30351 1.84766C2.63945 2.11328 2.1414 2.61133 1.87577 3.24219C1.47734 4.23828 1.57695 6.5625 1.57695 7.625C1.57695 8.7207 1.47734 11.0449 1.87577 12.0078C2.1414 12.6719 2.63945 13.1699 3.30351 13.4355C4.2664 13.834 6.59062 13.7344 7.68632 13.7344C8.74882 13.7344 11.073 13.834 12.0691 13.4355C12.7 13.1699 13.2312 12.6719 13.4637 12.0078Z'
                      fill='#E8721F'
                    />
                    <a href='https://www.instagram.com/care_ngr?igsh=MTc1amdpazVtNnRneQ' target='_blank' rel='noopener noreferrer'>
                      <rect
                        fill='black'
                        fill-opacity='0'
                        x='0.18925'
                        y='-1.275'
                        width='14.875'
                        height='19.55'
                      />
                    </a>
                  </svg>
                </div>
                {/* Pinterest */}
                <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                  <svg
                    width='14'
                    height='17'
                    viewBox='0 0 14 17'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M7.07676 0.357422C10.1979 0.357422 13.0533 2.51562 13.0533 5.80273C13.0533 8.89062 11.4596 12.3438 7.94004 12.3438C7.07676 12.3438 6.04746 11.9121 5.61582 11.1484C4.88535 14.1367 4.91855 14.6016 3.2584 16.8926C3.09238 16.959 3.12559 16.959 3.02598 16.8262C2.95957 16.1953 2.89316 15.5977 2.89316 14.9668C2.89316 12.9414 3.82285 9.98633 4.2877 8.02734C4.02207 7.49609 3.95566 6.89844 3.95566 6.33398C3.95566 3.67773 7.07676 3.2793 7.07676 5.4707C7.07676 6.76562 6.18027 7.99414 6.18027 9.25586C6.18027 10.0859 6.91074 10.6836 7.74082 10.6836C10.0318 10.6836 10.7291 7.39648 10.7291 5.63672C10.7291 3.2793 9.06895 1.98438 6.77793 1.98438C4.15488 1.98438 2.12949 3.87695 2.12949 6.5332C2.12949 7.82812 2.92637 8.49219 2.92637 8.79102C2.92637 9.05664 2.72715 9.95312 2.39512 9.95312C1.59824 9.95312 0.30332 8.625 0.30332 6.30078C0.30332 2.61523 3.65684 0.357422 7.07676 0.357422Z'
                      fill='#E8721F'
                    />
                    <a href='https://x.com/CARE_Nigeria' target='_blank' rel='noopener noreferrer'>
                      <rect
                        fill='black'
                        fill-opacity='0'
                        x='0.173438'
                        y='-1.275'
                        width='12.75'
                        height='19.55'
                      />
                    </a>
                  </svg>
                </div>
                {/* Twitter */}
                <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                  <svg
                    width='18'
                    height='15'
                    viewBox='0 0 18 15'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M15.4402 4.17188C15.4402 4.33789 15.4402 4.4707 15.4402 4.63672C15.4402 9.25195 11.9539 14.5312 5.5457 14.5312C3.55352 14.5312 1.72734 13.9668 0.200001 12.9707C0.465626 13.0039 0.731251 13.0371 1.03008 13.0371C2.65703 13.0371 4.15117 12.4727 5.34649 11.543C3.81914 11.5098 2.52422 10.5137 2.09258 9.11914C2.325 9.15234 2.52422 9.18555 2.75664 9.18555C3.05547 9.18555 3.3875 9.11914 3.65313 9.05273C2.05938 8.7207 0.864063 7.32617 0.864063 5.63281V5.59961C1.32891 5.86523 1.89336 5.99805 2.45781 6.03125C1.49492 5.40039 0.897266 4.33789 0.897266 3.14258C0.897266 2.47852 1.06328 1.88086 1.36211 1.38281C3.08867 3.47461 5.67852 4.86914 8.56719 5.03516C8.50078 4.76953 8.46758 4.50391 8.46758 4.23828C8.46758 2.3125 10.0281 0.751953 11.9539 0.751953C12.95 0.751953 13.8465 1.15039 14.5105 1.84766C15.2742 1.68164 16.0379 1.38281 16.702 0.984375C16.4363 1.81445 15.9051 2.47852 15.1746 2.91016C15.8719 2.84375 16.5691 2.64453 17.1668 2.37891C16.702 3.07617 16.1043 3.67383 15.4402 4.17188Z'
                      fill='#E8721F'
                    />
                    <a>
                      <rect
                        fill='black'
                        fill-opacity='0'
                        x='0.200001'
                        y='-1.275'
                        width='17'
                        height='19.55'
                      />
                    </a>
                  </svg>
                </div>
              </div>
            </div>

            {/* Subsribe */}
            {/* <div className='flex flex-col  space-y-6'>
              <h3 className='font-raleway font-bold text-2xl'>Subscribe</h3>
              <input
                type='email'
                placeholder='Enter your email:'
                className='w-80 px-4 py-4 mb-3 rounded-sm font-raleway text-black'
              />

              <button className='bg-orange-500 text-white px-4 py-4 mr-[199px] rounded font-raleway hover:bg-orange-600 '>
                SUBSCRIBE NOW
              </button>
            </div> */}
            {/* Links */}
            <div className='flex flex-col items-center teaxt-center space-y-5'>
              <h3 className='text-2xl font-bold font-raleway mr-16'>Links</h3>
              <ul className='space-y-3 font-raleway ml-14'>
                {[
                  { label: 'Courses', href: '/courses' },
                  // { label: 'Become A Learner', href: '/courses' },
                  { label: 'Become A Tutor', href: '/courses' },
                  { label: 'About Us', href: '/about' },
                  { label: 'Blog News', href: '/blog' },
                ].map((item, index) => (
                  <li key={index}>
                    <a
                      href={item.href}
                      className='flex items-center space-x-6 hover:text-orange-500'
                    >
                      {/* SVG icon */}
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='w-4 h-4 text-white'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M9 5l7 7-7 7'
                        />
                      </svg>
                      <span>{item.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Google App*/}
            <div className='flex flex-col  space-y-6'>
              <div className='text-left'>
                <h3 className='font-raleway font-bold text-2xl pr-20'>
                  Download
                </h3>
              </div>

              <div className='flex items-center justify-center py-6 space-x-3 '>
                <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                  <svg
                    width='41'
                    height='41'
                    viewBox='0 0 41 41'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667M20.5 7.16699H17.1667V17.167H13L20.5 24.667'
                      fill='white'
                    />
                    <path
                      d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667L13 17.167H17.1667V7.16699H20.5Z'
                      stroke='white'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M10.5 32.167H30.5'
                      stroke='white'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                </div>
                <div className='text-left'>
                  <img
                    src='./Google Play.png'
                    alt='Thumb 1'
                    className=' h-[62px] w-[290px]'
                  />
                </div>
              </div>
            </div>
          </div>
        </footer>

        <footer className='w-full h-[70.3px] bg-black space-y-4 py-16 px-6 md:px-20'>
          <div className='flex justify-center text-center'>
            <div className=' text-white text-center font-raleway text-sm'>
              Copyright © 2026{' '}
              <span className='text-orange-500'>CARE Nigeria</span> || All
              Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Courseos;
